<template>
  <div>
    <b-field label="Edit Floorplan">
      <div class="tools-container">
        <b-tooltip
          v-for="t in floorplanTools"
          :key="t.value"
          :label="t.name"
          position="is-right"
        >
          <b-button
            :type="buttonStyle(t.value)"
            v-on="{ click: onClick(t.value) }"
          >
            <span class="icon"><Icon :icon="t.icon"></Icon></span>
          </b-button>
        </b-tooltip>
      </div>
    </b-field>
    <b-field label="Edit Labels">
      <div class="tools-container">
        <b-tooltip
          v-for="t in labelTools"
          :key="t.value"
          :label="t.name"
          position="is-right"
        >
          <b-button
            v-on="{ click: onClick(t.value) }"
            :type="buttonStyle(t.value)"
          >
            <span class="icon"><Icon :icon="t.icon"></Icon></span>
          </b-button>
        </b-tooltip>
        <b-tooltip
          v-for="t in miscTools"
          :key="t.value"
          :label="t.name"
          position="is-right"
        >
          <b-button
            v-on="{ click: onClickMisc(t.value) }"
            :type="miscButtonStyle(t.value)"
          >
            <span class="icon"><Icon :icon="t.icon"></Icon></span>
          </b-button>
        </b-tooltip>
      </div>
    </b-field>
  </div>
</template>

<script>
import ui from "@/store/modules/ui";
import Icon from "./Icon";
import {
  mdiHand,
  mdiPencilPlus,
  mdiCursorMove,
  mdiDelete,
  mdiTransitConnection,
  mdiMagnet,
  mdiHeartPulse,
  mdiTag,
  mdiDoor,
  mdiWindowClosedVariant
} from "@mdi/js";
import useMisc from "../composables/useMisc";

export default {
  name: "ToolTypeSelector",
  components: { Icon },
  setup() {
    const floorplanTools = [
      {
        value: "pan",
        name: "Pan (H)",
        icon: mdiCursorMove
      },
      {
        value: "place",
        name: "Place (A)",
        icon: mdiPencilPlus
      },
      {
        value: "move",
        name: "Move (G)",
        icon: mdiHand
      },
      {
        value: "remove",
        name: "Remove (R)",
        icon: mdiDelete
      },
      {
        value: "connect",
        name: "Connect (C)",
        icon: mdiTransitConnection
      },
      {
        value: "snap",
        name: "Snap (S)",
        icon: mdiMagnet
      },
      {
        value: "detect",
        name: "Detect",
        icon: mdiHeartPulse
      }
    ];

    const labelTools = [
      {
        value: "placeLabel",
        name: "Place Label",
        icon: mdiTag
      },
      {
        value: "addDoor",
        name: "Add Door (D)",
        icon: mdiDoor
      },
      {
        value: "addWindow",
        name: "Add Window (W)",
        icon: mdiWindowClosedVariant
      }
    ];

    const { types: miscTools } = useMisc();

    const onClick = tool => () => {
      ui.setAnnoType(tool);
    };

    const onClickMisc = name => () => {
      ui.setAnnoType("placeMisc");
      ui.setMiscType(name);
    };

    const buttonStyle = tool => (ui.annoType === tool ? "is-info" : "");
    const miscButtonStyle = name => {
      if (ui.annoType === "placeMisc" && ui.selectedMiscType === name)
        return "is-info";
      else return "";
    };

    return {
      floorplanTools,
      labelTools,
      miscTools,
      onClick,
      onClickMisc,
      buttonStyle,
      miscButtonStyle
    };
  }
};
</script>

<style lang="scss" scoped>
.tools-container {
  display: flex;
  flex-wrap: wrap;
}

.tool {
  border-radius: 50px;
  background: #55b9f3;
  box-shadow: 20px 20px 60px #489dcf, -20px -20px 60px #62d5ff;
}
</style>
